import { useState } from 'react'
import type { TripType, CreateTripTypeInput, UpdateTripTypeInput } from '../types'

interface TripTypeFormProps {
  tripType?: TripType
  onSubmit: (data: CreateTripTypeInput | UpdateTripTypeInput) => void
  onCancel: () => void
  isEditing?: boolean
}

export default function TripTypeForm({ tripType, onSubmit, onCancel, isEditing = false }: TripTypeFormProps) {
  const [name, setName] = useState(tripType?.name || '')
  const [description, setDescription] = useState(tripType?.description || '')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!name.trim()) return

    const formData = {
      name: name.trim(),
      description: description.trim() || undefined,
    }

    if (isEditing && tripType) {
      onSubmit({ ...formData, id: tripType.id } as UpdateTripTypeInput)
    } else {
      onSubmit(formData as CreateTripTypeInput)
    }
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {isEditing ? 'Edit Trip Type' : 'Create New Trip Type'}
      </h3>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Name *
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Mountain Hiking, Copenhagen Work Trip"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />
        </div>

        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Optional description of this trip type..."
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          />
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="submit"
            disabled={!name.trim()}
            className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isEditing ? 'Update' : 'Create'}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 bg-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}